export default {"src":"/_next/static/media/perk-icon.0f8bb451.svg","height":38,"width":39,"blurWidth":0,"blurHeight":0};